export default __webpack_public_path__ + "static/media/motivations.0a5b9471.mp3";